import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./OnlineDot.scss";

const OnlineDot = ({ className }) => (
	<span
		className={classnames("onlinedot", className || "")}
		data-tooltip="Online now!"
		data-tooltip-padding="5" />
);

OnlineDot.propTypes = {
	className: PropTypes.string,
};

export default OnlineDot;



// WEBPACK FOOTER //
// ./src/shared/components/OnlineDot.jsx